import { render, staticRenderFns } from "./UiParticipantStatusHistory.vue?vue&type=template&id=6d930e5c"
import script from "./UiParticipantStatusHistory.vue?vue&type=script&lang=js"
export * from "./UiParticipantStatusHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports